export default {"src":"/_next/static/media/file-systems.61884b29.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};